import { SelectDropDownModule } from 'ngx-select-dropdown';
import { BreadcrumbComponentModule } from "./../_component/breadcrumb/breadcrumb.module";
import { CommonModule } from "@angular/common";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { OwlDateTimeModule } from "@danielmoncada/angular-datetime-picker";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { SocketIoModule } from "ngx-socket-io";
import { PaginationClientSideModule } from "src/app/app/_component/pagination-client-side/pagination-client-side.module";
import { SearchBarModule } from "src/app/app/_component/search-bar/search-bar.module";
import { SelectDropdownModule } from "src/app/app/_component/select-dropdown/select-dropdown.module";
import { HeaderModule } from "src/app/_component/header/header.module";
import { LoadingStiModule } from "src/app/_component/loading-sti/loading-sti.module";
import { SharedDirectivesModule } from "src/app/_directives/shared-directives.module";
import { JwtInterceptor } from "src/app/_helpers/jwt.interceptor";
import { CustomSocket } from "src/app/_services/custom-socket.service";
import { EntryViewComponentModule } from "./entry-view/entry-view.module";
import { InvitationPageRoutingModule } from "./invitation-routing.module";
import { InvitationViewModule } from "./invitation-view/invitation-view.module";
import { InvitationPage } from "./invitation.page";
import { InvitationFilterModalComponentModule } from "./invitation-filter-modal/invitation-filter-modal.module";
import { MobileFilterComponentModule } from "../_component/_structural/mobile-filter/mobile-filter.module";
import { ListHeaderComponentModule } from "../_component/_structural/list-header/list-header.module";
import { DateTimePickerComponentModule } from "../_component/date-time-picker/date-time-picker.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    IonicModule,
    InvitationPageRoutingModule,
    TranslateModule,
    HeaderModule,
    PaginationClientSideModule,
    InvitationViewModule,
    EntryViewComponentModule,
    SharedDirectivesModule,
    SearchBarModule,
    LoadingStiModule,
    SelectDropdownModule,
    OwlDateTimeModule,
    SocketIoModule,
    BreadcrumbComponentModule,
    InvitationFilterModalComponentModule,
    MobileFilterComponentModule,
    ListHeaderComponentModule,
    DateTimePickerComponentModule,
    SelectDropdownModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    CustomSocket,
  ],
  declarations: [InvitationPage],
})
export class InvitationPageModule {}
